import { useCallback, useState } from 'react';

/**
 * Хук, позволяющий понять, есть ли ховер хотя бы над одним из элементов, на которые навешены слушатели mouseEnter и Leave.
 * Удобно, когда показываем поповер по ховеру, и не хотим прятать его, когда ушли с оригинального элемента (который показывает
 * поповер) на собственно сам поповер.
 * При необходимости можно добавить функциональность задержки
 */
export function useMultipleHover() {
  const [hoveredCount, setHoveredCount] = useState(0);

  const onMouseEnter = useCallback(() => {
    setHoveredCount((prev) => prev + 1);
  }, []);

  const onMouseLeave = useCallback(() => {
    setHoveredCount((prev) => prev - 1);
  }, []);

  return {
    isHovered: hoveredCount > 0,
    onMouseEnter,
    onMouseLeave,
  };
}
